module.exports = __webpack_public_path__ + "static/img/faceHome.3659c729.png";